import React, { useEffect, useState } from 'react';
import Fetcher from '../Common/Fetch';

const DocumentLink = ({ documentName, documentPath, download, blank }) => {
    const [documentLink, setDocumentLink] = useState("");

    const getPathDetails = async () => {
        try {
            const response = await Fetcher(`/Document/PathDetails?path=${documentPath}&Name=${documentName}`, {
                method: "GET"
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setDocumentLink(url);
            } else {
                console.error("Ошибка при запросе", response.statusText);
            }
        } catch (error) {
            console.error("Исключение", error);
        }
    };

    useEffect(() => {
        if (download) {
            getPathDetails();
        }
    }, [download, documentPath, documentName]);

    if (!documentPath) {
        return <span>{documentName}</span>;
    }

    return (
        <div>
            {download ?
                <a className="blueLink" style={{color: "blue", fontWeight: "500"}} href={documentLink} download>
                    {documentName}
                </a> : blank ?
                    <a className="blueLink" style={{color: "blue", fontWeight: "500" }} href={documentPath} target="_blank" rel="noopener noreferrer">
                        {documentName}
                    </a> : <a className="blueLink" style={{color: "blue", fontWeight: "500" }} href={documentPath}>
                        {documentName}
                    </a>}
        </div>
    );
};

export default DocumentLink;